export const CURRENT_CONFIG = {

    // license
    appId: '159611', // You need to go to the development website to apply.
    appKey: 'dea7809be8189d4e7dd45664ad0aa95', // You need to go to the development website to apply.
    appLicense: 'x3G/7fd6G+Or+z93kFTj5fg0aw0Q+7vgNyvDRKlj9Iij79VNaweG+Od9o0Xa1+I4/Sbd26EwctnfWAbt9SwIj2xtK+Pz2k2AYgUvPJtNU1q+4RDVqsCRXUhJ9KWye/fjfbiaxRuQlpPuDNdT3NF0jVERiKhEWFZLBJNnEsQiwvo=', // You need to go to the development website to apply.

    // http
    baseURL: 'https://stghubapi.droneqube.com/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
    websocketURL: 'wss://stghubapi.droneqube.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

    // livestreaming
    // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
    rtmpURL: 'rtmp://stgrtmp.droneqube.com/live/', // Example: 'rtmp://192.168.1.1/live/'
    // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
    gbServerIp: 'Please enter the server ip.',
    gbServerPort: 'Please enter the server port.',
    gbServerId: 'Please enter the server id.',
    gbAgentId: 'Please enter the agent id',
    gbPassword: 'Please enter the agent password',
    gbAgentPort: 'Please enter the local port.',
    gbAgentChannel: 'Please enter the channel.',
    // RTSP
    rtspUserName: 'viewer',
    rtspPassword: 'viewerpassword',
    rtspPort: '8554',
    // Agora
    agoraAPPID: 'Please enter the agora app id.',
    agoraToken: 'Please enter the agora temporary token.',
    agoraChannel: 'Please enter the agora channel.',

    // map
    // You can apply on the AMap website.
    amapKey: 'Please enter the amap key.',

}
